import { createAction } from 'redux-actions-helpers'
import { UserItemType } from './types'

export const fetchUsers = createAction(
  '@@admin-users/FETCH_USERS',
  (page: number): any => ({ page })
)

export const fetchUsersSuccess = createAction(
  '@@admin-users/FETCH_USERS_SUCCESS',
  (result: UserItemType[]): any => ({ result })
)

export const fetchUsersFailure = createAction(
  '@@admin-users/FETCH_USERS_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-users/DESTROY')
